package com.anjuros.website.templates.template5.util

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType


enum class ResKey: ResKeyType {


    TEMPLATE5_SECTION1,
    TEMPLATE5_SECTION2,
    TEMPLATE5_SECTION3,
    TEMPLATE5_SECTION4,
    TEMPLATE5_CONTACT,
    TEMPLATE5_PRODUCTS_MAIN_TITLE,
    TEMPLATE5_ABOUT,

    TEMPLATE5_PRODUCTS_FROM,
    TEMPLATE5_CATEGORY1,
    TEMPLATE5_CATEGORY2,
    TEMPLATE5_CATEGORY3,
    TEMPLATE5_CATEGORY4,
    TEMPLATE5_CATEGORY5,

    TEMPLATE5_CATEGORY1_PRODUCT1_TITLE,
    TEMPLATE5_CATEGORY1_PRODUCT1_TEXT,
    TEMPLATE5_CATEGORY1_PRODUCT2_TITLE,
    TEMPLATE5_CATEGORY1_PRODUCT2_TEXT,
    TEMPLATE5_CATEGORY1_PRODUCT3_TITLE,
    TEMPLATE5_CATEGORY1_PRODUCT3_TEXT,
    TEMPLATE5_CATEGORY1_PRODUCT4_TITLE,
    TEMPLATE5_CATEGORY1_PRODUCT4_TEXT,
    TEMPLATE5_CATEGORY1_PRODUCT5_TITLE,
    TEMPLATE5_CATEGORY1_PRODUCT5_TEXT,
    TEMPLATE5_CATEGORY1_PRODUCT6_TITLE,
    TEMPLATE5_CATEGORY1_PRODUCT6_TEXT,

    TEMPLATE5_CATEGORY2_PRODUCT1_TITLE,
    TEMPLATE5_CATEGORY2_PRODUCT1_TEXT,
    TEMPLATE5_CATEGORY2_PRODUCT2_TITLE,
    TEMPLATE5_CATEGORY2_PRODUCT2_TEXT,
    TEMPLATE5_CATEGORY2_PRODUCT3_TITLE,
    TEMPLATE5_CATEGORY2_PRODUCT3_TEXT,
    TEMPLATE5_CATEGORY2_PRODUCT4_TITLE,
    TEMPLATE5_CATEGORY2_PRODUCT4_TEXT,
    TEMPLATE5_CATEGORY2_PRODUCT5_TITLE,
    TEMPLATE5_CATEGORY2_PRODUCT5_TEXT,

    TEMPLATE5_CATEGORY3_PRODUCT1_TITLE,
    TEMPLATE5_CATEGORY3_PRODUCT1_TEXT,
    TEMPLATE5_CATEGORY3_PRODUCT2_TITLE,
    TEMPLATE5_CATEGORY3_PRODUCT2_TEXT,
    TEMPLATE5_CATEGORY3_PRODUCT3_TITLE,
    TEMPLATE5_CATEGORY3_PRODUCT3_TEXT,
    TEMPLATE5_CATEGORY3_PRODUCT4_TITLE,
    TEMPLATE5_CATEGORY3_PRODUCT4_TEXT,
    TEMPLATE5_CATEGORY3_PRODUCT5_TITLE,
    TEMPLATE5_CATEGORY3_PRODUCT5_TEXT,

    TEMPLATE5_CATEGORY4_PRODUCT1_TITLE,
    TEMPLATE5_CATEGORY4_PRODUCT1_TEXT,
    TEMPLATE5_CATEGORY4_PRODUCT2_TITLE,
    TEMPLATE5_CATEGORY4_PRODUCT2_TEXT,
    TEMPLATE5_CATEGORY4_PRODUCT3_TITLE,
    TEMPLATE5_CATEGORY4_PRODUCT3_TEXT,
    TEMPLATE5_CATEGORY4_PRODUCT4_TITLE,
    TEMPLATE5_CATEGORY4_PRODUCT4_TEXT,

    TEMPLATE5_CATEGORY5_PRODUCT1_TITLE,
    TEMPLATE5_CATEGORY5_PRODUCT1_TEXT,
    TEMPLATE5_CATEGORY5_PRODUCT2_TITLE,
    TEMPLATE5_CATEGORY5_PRODUCT2_TEXT,
    TEMPLATE5_CATEGORY5_PRODUCT3_TITLE,
    TEMPLATE5_CATEGORY5_PRODUCT3_TEXT,
    TEMPLATE5_CATEGORY5_PRODUCT4_TITLE,
    TEMPLATE5_CATEGORY5_PRODUCT4_TEXT,
    TEMPLATE5_CATEGORY5_PRODUCT5_TITLE,
    TEMPLATE5_CATEGORY5_PRODUCT5_TEXT,



    CONTACT_DROP_OTHER,
    CONTACT_DROP1_LABEL,
    CONTACT_DROP1_PLACEHOLDER,
    CONTACT_DROP1_PLACEHOLDER2,

    /////////////
    TEMPLATE5_HERO_BADGE,

    TEMPLATE5_HERO_TITLE,

    TEMPLATE5_HERO_DESCRIPTION,

    TEMPLATE5_HERO_BUTTON_ORDER,

    TEMPLATE5_HERO_BUTTON_PRODUCTS,

    TEMPLATE5_HERO_FEATURE1_TITLE,
    TEMPLATE5_HERO_FEATURE1_TEXT,

    TEMPLATE5_HERO_FEATURE2_TITLE,
    TEMPLATE5_HERO_FEATURE2_TEXT,

    TEMPLATE5_HERO_FEATURE3_TITLE,
    TEMPLATE5_HERO_FEATURE3_TEXT,

    TEMPLATE5_PRODUCTS_BADGE,
    TEMPLATE5_PRODUCTS_DESC,


    TEMPLATE5_ABOUT_BADGE,

    TEMPLATE5_ABOUT_INTRO1,
    TEMPLATE5_ABOUT_INTRO2,

    TEMPLATE5_ABOUT_PARAGRAPH1,
    TEMPLATE5_ABOUT_PARAGRAPH2,

    TEMPLATE5_ACHIEVEMENT1,
    TEMPLATE5_ACHIEVEMENT2,
    TEMPLATE5_ACHIEVEMENT3,

    TEMPLATE5_REVIEWS_BADGE,
    TEMPLATE5_REVIEWS_TITLE,
    TEMPLATE5_REVIEWS_TEXT,

    TEMPLATE5_REVIEW1_TITLE,
    TEMPLATE5_REVIEW1,
    TEMPLATE5_REVIEW1_NAME,

    TEMPLATE5_REVIEW2_TITLE,
    TEMPLATE5_REVIEW2,
    TEMPLATE5_REVIEW2_NAME,

    TEMPLATE5_REVIEW3_TITLE,
    TEMPLATE5_REVIEW3,
    TEMPLATE5_REVIEW3_NAME,
    TEMPLATE5_FAQ_BADGE,
    TEMPLATE5_FAQ_TITLE,
    TEMPLATE5_FAQ_TEXT,

    TEMPLATE5_FAQ1_Q,
    TEMPLATE5_FAQ1_A,

    TEMPLATE5_FAQ2_Q,
    TEMPLATE5_FAQ2_A,

    TEMPLATE5_FAQ3_Q,
    TEMPLATE5_FAQ3_A,

    TEMPLATE5_FAQ4_Q,
    TEMPLATE5_FAQ4_A,

    TEMPLATE5_FAQ5_Q,
    TEMPLATE5_FAQ5_A,


    TEMPLATE5_CONTACT_BADGE,
    TEMPLATE5_CONTACT_TITLE,
    TEMPLATE5_CONTACT_SUBTITLE,
    TEMPLATE5_CONTACT_CARD_TITLE,
    TEMPLATE5_CONTACT_CARD_TEXT,

    TEMPLATE5_CONTACT_PHONE_TITLE,
    TEMPLATE5_CONTACT_PHONE,

    TEMPLATE5_CONTACT_EMAIL_TITLE,
    TEMPLATE5_CONTACT_EMAIL,

    TEMPLATE5_CONTACT_COLLECTION_TITLE,
    TEMPLATE5_CONTACT_COLLECTION,

    TEMPLATE5_CONTACT_INSTAGRAM_TITLE,
    TEMPLATE5_CONTACT_INSTAGRAM,

    TEMPLATE5_CONTACT_CARD_FOOTER,
    TEMPLATE5_FOOTER_COPYRIGHT,
    TEMPLATE5_HEADER_HOME,
    TEMPLATE5_HEADER_PRODUCTS,
    TEMPLATE5_HEADER_ABOUT,
    TEMPLATE5_HEADER_REVIEWS,
    TEMPLATE5_HEADER_FAQ,
    TEMPLATE5_HEADER_CONTACT,
    ;
    override val keyName: String
        get() = name


}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(


        ResKey.TEMPLATE5_SECTION1 to "About Me",
        ResKey.TEMPLATE5_SECTION2 to "Products",
        ResKey.TEMPLATE5_SECTION3 to "Reviews",
        ResKey.TEMPLATE5_SECTION4 to "Contact",
        ResKey.TEMPLATE5_CONTACT to "Contact me!",

        ResKey.TEMPLATE5_CATEGORY1 to "Birthday Cakes",
        ResKey.TEMPLATE5_CATEGORY2 to "Wedding Cakes",
        ResKey.TEMPLATE5_CATEGORY3 to "Cupcakes",
        ResKey.TEMPLATE5_CATEGORY4 to "Cookies",
        ResKey.TEMPLATE5_CATEGORY5 to "Tarts",

//====================================================
// CATEGORY 1
//====================================================

        ResKey.TEMPLATE5_PRODUCTS_BADGE to "OUR PRODUCTS",

        ResKey.TEMPLATE5_PRODUCTS_MAIN_TITLE to "Browse Our Delicious Selection",

        ResKey.TEMPLATE5_PRODUCTS_DESC to "From celebration cakes to sweet treats, explore our handcrafted range made with quality ingredients. Select a category to discover our collection.",

        ResKey.TEMPLATE5_PRODUCTS_FROM to "From",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT6_TITLE to "Vanilla Fun Cake",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT6_TEXT to "Vanilla cake with rainbow sprinkles and cream topping.",

        ResKey.TEMPLATE5_CATEGORY1_PRODUCT4_TITLE to "Elegant Vanilla Cake",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT4_TEXT to "Minimalist design with elegant flavour.",

        ResKey.TEMPLATE5_CATEGORY1_PRODUCT2_TITLE to "Classic Chocolate Cake",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT2_TEXT to "Rich chocolate sponge with chocolate ganache.",

        ResKey.TEMPLATE5_CATEGORY1_PRODUCT3_TITLE to "Triple Choco Delight",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT3_TEXT to "Three layers of chocolate heaven.",

        ResKey.TEMPLATE5_CATEGORY1_PRODUCT5_TITLE to "Chocolate Fudge Layers",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT5_TEXT to "Chocolate sponge stacked high with velvety fudge frosting, each bite bursting with deep cocoa flavour.",

        ResKey.TEMPLATE5_CATEGORY1_PRODUCT1_TITLE to "Strawberry Shortcake",
        ResKey.TEMPLATE5_CATEGORY1_PRODUCT1_TEXT to "Classic sponge layered with whipped cream and fresh strawberries.",

//====================================================
// CATEGORY 2
//====================================================

        ResKey.TEMPLATE5_CATEGORY2_PRODUCT1_TITLE to "Chocolate Berry Cascade",
        ResKey.TEMPLATE5_CATEGORY2_PRODUCT1_TEXT to "Elegant cake with chocolate buttercream and cascading fresh raspberries.",

        ResKey.TEMPLATE5_CATEGORY2_PRODUCT5_TITLE to "Almond Rose Cake",
        ResKey.TEMPLATE5_CATEGORY2_PRODUCT5_TEXT to "Almond-infused vanilla cake decorated with handmade rose fondant for weddings.",

        ResKey.TEMPLATE5_CATEGORY2_PRODUCT2_TITLE to "Golden Bubbles Tier",
        ResKey.TEMPLATE5_CATEGORY2_PRODUCT2_TEXT to "Champagne-flavoured three-tier cake with golden accents and vanilla mousse layers.",

        ResKey.TEMPLATE5_CATEGORY2_PRODUCT3_TITLE to "Strawberry Champagne",
        ResKey.TEMPLATE5_CATEGORY2_PRODUCT3_TEXT to "Champagne sponge with strawberry filling and soft whipped icing, ideal for tastings.",

        ResKey.TEMPLATE5_CATEGORY2_PRODUCT4_TITLE to "Elderflower Essence Cake",
        ResKey.TEMPLATE5_CATEGORY2_PRODUCT4_TEXT to "Subtle elderflower cream layered with lemon cake and fondant detailing.",

//====================================================
// CATEGORY 3
//====================================================


        ResKey.TEMPLATE5_CATEGORY3_PRODUCT3_TITLE to "Rainbow Swirl Minis",
        ResKey.TEMPLATE5_CATEGORY3_PRODUCT3_TEXT to "Mini cupcakes with funfetti sponge and vibrant swirl buttercream, perfect for kids' parties.",

        ResKey.TEMPLATE5_CATEGORY3_PRODUCT2_TITLE to "Confetti Celebration Pack",
        ResKey.TEMPLATE5_CATEGORY3_PRODUCT2_TEXT to "Box of 6 colourful cupcakes with sugar confetti topping and a festive message plaque.",

        ResKey.TEMPLATE5_CATEGORY3_PRODUCT4_TITLE to "Café Cupcake Trio",
        ResKey.TEMPLATE5_CATEGORY3_PRODUCT4_TEXT to "Three assorted mocha cupcakes in a gift box: classic, dark roast, and vanilla mocha.",

        ResKey.TEMPLATE5_CATEGORY3_PRODUCT1_TITLE to "Mint Choco Chip Cupcakes",
        ResKey.TEMPLATE5_CATEGORY3_PRODUCT1_TEXT to "Chocolate sponge cupcakes with mint frosting and mini chocolate chips on top.",

//====================================================
// CATEGORY 4
//====================================================

        ResKey.TEMPLATE5_CATEGORY4_PRODUCT2_TITLE to "Classic Choco Chip Cookies",
        ResKey.TEMPLATE5_CATEGORY4_PRODUCT2_TEXT to "Golden-baked cookies with gooey chocolate chips and a hint of vanilla.",

        ResKey.TEMPLATE5_CATEGORY4_PRODUCT1_TITLE to "Spiced Oatmeal Cookies",
        ResKey.TEMPLATE5_CATEGORY4_PRODUCT1_TEXT to "Oatmeal raisin cookies with added nutmeg and ginger for a warm flavour.",

        ResKey.TEMPLATE5_CATEGORY4_PRODUCT4_TITLE to "Chocolate Dipped PB",
        ResKey.TEMPLATE5_CATEGORY4_PRODUCT4_TEXT to "Peanut butter cookies dipped in dark chocolate and sprinkled with sea salt.",

        ResKey.TEMPLATE5_CATEGORY4_PRODUCT3_TITLE to "Cinnamon Sugar Swirls",
        ResKey.TEMPLATE5_CATEGORY4_PRODUCT3_TEXT to "Extra cinnamon-swirled snickerdoodles with a chewy centre and crisp edges.",

//====================================================
// CATEGORY 5
//====================================================

        ResKey.TEMPLATE5_CATEGORY5_PRODUCT2_TITLE to "Fresh Fruit Tart",
        ResKey.TEMPLATE5_CATEGORY5_PRODUCT2_TEXT to "Buttery tart crust filled with vanilla custard and topped with seasonal fresh fruits.",

        ResKey.TEMPLATE5_CATEGORY5_PRODUCT4_TITLE to "Berry Blossom Tart",
        ResKey.TEMPLATE5_CATEGORY5_PRODUCT4_TEXT to "An elegant tart with raspberry, blueberry, and blackberry over rich custard.",

        ResKey.TEMPLATE5_CATEGORY5_PRODUCT1_TITLE to "Mini Fruit Tartlets",
        ResKey.TEMPLATE5_CATEGORY5_PRODUCT1_TEXT to "Assortment of bite-sized tarts with kiwi, mango, and strawberry topping.",

        ResKey.TEMPLATE5_CATEGORY5_PRODUCT5_TITLE to "Lemon Meringue Tart",
        ResKey.TEMPLATE5_CATEGORY5_PRODUCT5_TEXT to "Tart lemon filling topped with lightly browned fluffy meringue.",

        ResKey.TEMPLATE5_CATEGORY5_PRODUCT3_TITLE to "Chocolate Nut Tart",
        ResKey.TEMPLATE5_CATEGORY5_PRODUCT3_TEXT to "Chocolate ganache layered over roasted nut base with praline crunch.",



        ResKey.CONTACT_DROP1_LABEL to "What can I bake for you?",
        ResKey.CONTACT_DROP1_PLACEHOLDER to "Select",
        ResKey.CONTACT_DROP1_PLACEHOLDER2 to "Select cake",
        ResKey.CONTACT_DROP_OTHER to "Other",


        //////////////////////////////

        ResKey.TEMPLATE5_HERO_BADGE to "HANDCRAFTED BAKES",

        ResKey.TEMPLATE5_HERO_TITLE to "Beautiful Cakes \nMade for Every Celebration",

        ResKey.TEMPLATE5_HERO_DESCRIPTION to "From birthday cakes and wedding creations to cupcakes, cookies and sweet treats, every order is freshly baked with care using quality ingredients and finished with attention to every detail.",

        ResKey.TEMPLATE5_HERO_BUTTON_ORDER to "Get in Touch",

        ResKey.TEMPLATE5_HERO_BUTTON_PRODUCTS to "Browse Our Cakes",

        ResKey.TEMPLATE5_HERO_FEATURE1_TITLE to "Made Fresh",
        ResKey.TEMPLATE5_HERO_FEATURE1_TEXT to "Freshly baked to order.",

        ResKey.TEMPLATE5_HERO_FEATURE2_TITLE to "Custom Designs",
        ResKey.TEMPLATE5_HERO_FEATURE2_TEXT to "Created for every occasion.",

        ResKey.TEMPLATE5_HERO_FEATURE3_TITLE to "Quality Ingredients",
        ResKey.TEMPLATE5_HERO_FEATURE3_TEXT to "Beautiful inside and out.",



        ResKey.TEMPLATE5_ABOUT_BADGE to "ABOUT ME",

        ResKey.TEMPLATE5_ABOUT_INTRO1 to "Hi, I'm Emily!",
        ResKey.TEMPLATE5_ABOUT_INTRO2 to "Emily ♡",

        ResKey.TEMPLATE5_ABOUT_PARAGRAPH1 to "Baking has always been my passion. What started as a hobby in my small kitchen has grown into Sweet Creations, a place where every cake is made with love, care and attention to detail.",

        ResKey.TEMPLATE5_ABOUT_PARAGRAPH2 to "I believe every celebration deserves something special, and I'm here to create the perfect cake for your unforgettable moments.",

        ResKey.TEMPLATE5_ACHIEVEMENT1 to "Started Baking",

        ResKey.TEMPLATE5_ACHIEVEMENT2 to "Happy Customers",

        ResKey.TEMPLATE5_ACHIEVEMENT3 to "Made to Order",
        ResKey.TEMPLATE5_REVIEWS_BADGE to "CUSTOMER REVIEWS",

        ResKey.TEMPLATE5_REVIEWS_TITLE to "Sweet Words From Happy Customers",

        ResKey.TEMPLATE5_REVIEWS_TEXT to "Every cake is made with care, and nothing makes me happier than seeing customers enjoy them. Here's what a few of them had to say.",

        ResKey.TEMPLATE5_REVIEW1_NAME to "Sarah Johnson",
        ResKey.TEMPLATE5_REVIEW1_TITLE to "Birthday Cake",

        ResKey.TEMPLATE5_REVIEW1 to "Emily created the most beautiful birthday cake for our daughter. It looked incredible, tasted even better and was the highlight of the party. We'll definitely be ordering again!",

        ResKey.TEMPLATE5_REVIEW2_NAME to "Emma Williams",
        ResKey.TEMPLATE5_REVIEW2_TITLE to "Wedding Cake",

        ResKey.TEMPLATE5_REVIEW2 to "Our wedding cake was everything we hoped for. Every detail was perfect, and so many guests commented on how delicious it was. Thank you for making our day so special!",

        ResKey.TEMPLATE5_REVIEW3_NAME to "Rachel Brown",
        ResKey.TEMPLATE5_REVIEW3_TITLE to "Cupcake Order",

        ResKey.TEMPLATE5_REVIEW3 to "The cupcakes were fresh, beautifully decorated and full of flavour. Communication was fantastic from start to finish and the whole experience was effortless.",

        ResKey.TEMPLATE5_FAQ_BADGE to "FAQ",

        ResKey.TEMPLATE5_FAQ_TITLE to "Frequently Asked Questions",

        ResKey.TEMPLATE5_FAQ_TEXT to "Have a question? Here are some of the things customers ask most often before placing an order.",

        ResKey.TEMPLATE5_FAQ1_Q to "How much notice do I need to place an order?",
        ResKey.TEMPLATE5_FAQ1_A to "I recommend ordering at least one week in advance. Wedding cakes and larger celebration cakes may require more notice, especially during busy periods.",

        ResKey.TEMPLATE5_FAQ2_Q to "Can I request a custom cake design?",
        ResKey.TEMPLATE5_FAQ2_A to "Absolutely! Every celebration is unique, so I'm happy to create a cake tailored to your theme, colours and ideas.",

        ResKey.TEMPLATE5_FAQ3_Q to "Do you offer gluten-free or vegan options?",
        ResKey.TEMPLATE5_FAQ3_A to "Yes, I offer a selection of gluten-free and vegan cakes. Please get in touch to discuss your specific dietary requirements.",

        ResKey.TEMPLATE5_FAQ4_Q to "Do you deliver or is it collection only?",
        ResKey.TEMPLATE5_FAQ4_A to "Collection is available for all orders, and local delivery can be arranged for larger cakes depending on your location.",

        ResKey.TEMPLATE5_FAQ5_Q to "How should I store my cake?",
        ResKey.TEMPLATE5_FAQ5_A to "Most cakes are best kept in a cool place and enjoyed within a few days. I'll include care instructions with every order.",

        ResKey.TEMPLATE5_CONTACT_BADGE to "GET IN TOUCH",

        ResKey.TEMPLATE5_CONTACT_TITLE to "Let's Create Something Sweet",

        ResKey.TEMPLATE5_CONTACT_SUBTITLE to "Whether you're planning a birthday, wedding or another special occasion, I'd love to hear your ideas.",

        ResKey.TEMPLATE5_CONTACT_CARD_TITLE to "Let's make your \ncelebration extra special!",
        ResKey.TEMPLATE5_CONTACT_CARD_TEXT to "Tell me a little about your celebration and I'll help create a cake that's as memorable as the occasion itself.",

        ResKey.TEMPLATE5_CONTACT_PHONE_TITLE to "Phone",
        ResKey.TEMPLATE5_CONTACT_PHONE to "07700 123456",

        ResKey.TEMPLATE5_CONTACT_EMAIL_TITLE to "Email",
        ResKey.TEMPLATE5_CONTACT_EMAIL to "hello@sweetcreations.co.uk",

        ResKey.TEMPLATE5_CONTACT_COLLECTION_TITLE to "Collection",
        ResKey.TEMPLATE5_CONTACT_COLLECTION to "By appointment only",

        ResKey.TEMPLATE5_CONTACT_INSTAGRAM_TITLE to "Instagram",
        ResKey.TEMPLATE5_CONTACT_INSTAGRAM to "@sweetcreations",
        ResKey.TEMPLATE5_CONTACT_CARD_FOOTER to "Creating handcrafted cakes and sweet treats for birthdays, weddings and every special occasion.",

        ResKey.TEMPLATE5_FOOTER_COPYRIGHT to "© 2026 Anjuros Development. All rights reserved.",

        ResKey.TEMPLATE5_HEADER_HOME to "Home",

        ResKey.TEMPLATE5_HEADER_PRODUCTS to "Products",

        ResKey.TEMPLATE5_HEADER_ABOUT to "About",

        ResKey.TEMPLATE5_HEADER_REVIEWS to "Reviews",

        ResKey.TEMPLATE5_HEADER_FAQ to "FAQ",

        ResKey.TEMPLATE5_HEADER_CONTACT to "Contact",
        ),
)
